import { of } from "rxjs";
import { ofType, combineEpics } from "redux-observable";
import { mergeMap } from "rxjs/operators";
import { loadFlightControl } from "../FlightDetails/FlightDetails.ducks.js";
import { loadOverview } from "../../ducks/FlightOverview.ducks.js";
import { updateFlightActionTypes, updatingFlight, updatedFlight, navigateToDetails, navigatedToDetails, loadPathsActionTypes, loadingManagementGroupPaths, loadedManagementGroupPaths } from "./FlightEdit.ducks.js";
import * as ReduxObservablesEpicUtils from "@ane/core/lib/utils/ReduxObservablesEpicUtils";
import { getTenantFromManagementGroup } from "@ane/exp-data/lib/utils/ManagementGroup";
import FlightResource from "../../resources/Flight.resource.js";
import { AsyncRequestStatus, getCompletedAsyncWrapperObj } from "@ane/core/lib/models/IAsyncWrapper";
import MdsDataplaneResource from "@ane/exp-data/lib/resources/MdsDataplaneResource";
import NavigationService from "@ane/core/lib/services/NavigationService";
import "../../../../utils/FlightRoute.utils.js";
import { constructFlightDetailsURL } from "@ane/exp-data/lib/routes/FlightRoute.utils";
const updateFlightArgs = {
  filterOnType: updateFlightActionTypes.UPDATE,
  loadResource: (payload, state) => {
    const { flightId, workspaceId, managementGroup, configuration } = payload;
    return FlightResource.updateFlight(
      flightId,
      workspaceId,
      managementGroup,
      getTenantFromManagementGroup(managementGroup),
      configuration || {}
    );
  },
  loadingAction: updatingFlight,
  loadedAction: (successData, payload, error) => {
    var _a, _b;
    if (!error) {
      const result = { status: AsyncRequestStatus.Completed, error: "" };
      const workspaceId = ((_a = payload.configuration) == null ? void 0 : _a.WorkspaceId) || payload.workspaceId;
      const updatedManagementGroup = ((_b = payload.configuration) == null ? void 0 : _b.ManagementGroup) || payload.managementGroup;
      return of(
        updatedFlight(payload, result),
        loadOverview(payload.flightId, workspaceId, updatedManagementGroup),
        loadFlightControl(payload.flightId, workspaceId, updatedManagementGroup),
        navigateToDetails(payload.flightId, workspaceId, updatedManagementGroup)
      );
    } else {
      return of(updatedFlight(payload, { status: AsyncRequestStatus.Failed, error }));
    }
  }
};
const updateFlightEpic = ReduxObservablesEpicUtils.produceLoadLoadingLoadedEpic(updateFlightArgs);
const navigateToDetailsEpic = (action$) => {
  return action$.pipe(
    ofType(updateFlightActionTypes.NAVIGATE_TO_DETAILS),
    mergeMap((action) => {
      const { flightId, workspaceId, managementGroup } = action.payload;
      NavigationService.navigateTo(constructFlightDetailsURL(flightId, workspaceId, managementGroup));
      return of(navigatedToDetails());
    })
  );
};
const loadManagementGroupPathsArgs = {
  filterOnType: loadPathsActionTypes.LOAD,
  loadResource: (payload, state) => {
    const { workspaceId } = payload;
    return MdsDataplaneResource.getPaths(workspaceId, false);
  },
  loadingAction: loadingManagementGroupPaths,
  loadedAction: (successData, payload, error) => {
    const tenantPaths = (successData || []).filter(
      (p) => p.toLocaleLowerCase().indexOf(payload.tenant.toLocaleLowerCase()) === 1
    );
    return of(loadedManagementGroupPaths(payload.flightId, getCompletedAsyncWrapperObj(tenantPaths, error || "")));
  }
};
const loadManagementGroupPathsEpic = ReduxObservablesEpicUtils.produceLoadLoadingLoadedEpic(loadManagementGroupPathsArgs);
const FlightEditEpics = combineEpics(updateFlightEpic, navigateToDetailsEpic, loadManagementGroupPathsEpic);
export {
  FlightEditEpics as default,
  loadManagementGroupPathsEpic,
  navigateToDetailsEpic,
  updateFlightEpic
};
//# sourceMappingURL=FlightEdit.epics.js.map
